import icon from '@/presentation/assets/images/icons/tool-disclosure.svg';
import type { CustomQueryParams } from '@/services/router-proxy/types';
import { type Manifest, type RouterConfig, type ToolConfig, PAGE_TYPE } from '@/types/manifest.ts';

const routerConfig: RouterConfig = {
    type: PAGE_TYPE.TOOL,
    name: 'disclosure',
    exclusiveRoutePath: '/disclosure',
    getComponent: () => import('./Disclosure.vue'),
};

const toolConfig: ToolConfig = {
    tabIndex: 2,
    label: 'drafting.Disclosure',
    icon,
    aclCheckPath: (permission) => permission.disclosure,
};


export const manifest: Manifest = {
    ...routerConfig,
    ...toolConfig,
};

declare module '@patsnap/tahiti-core' {
    export interface CommandService {
        /**
         * 去到 AI 交底书页面
         * @param commandId - 命令(去到 AI 交底书页面)
         * @param params - 参数(包含任务 ID)
         */
        executeCommand(commandId: 'command:route:disclosure', params?: CustomQueryParams): void;
        /**
         * 去到 AI 交底书页面(新窗口打开)
         * @param commandId - 命令(去到 AI 交底书页面(新窗口打开))
         * @param taskId - 任务 ID, 如果未提供，即创建新任务
         */
        executeCommand(commandId: 'command:route:disclosure:new-tab', taskId?: string): void;
    }
}
